module.exports = __webpack_public_path__ + "img/mobile_btn10.c6d0dc82.png";